<template>
    <div>
        <el-form :ref="form.ref" :model="formData" :label-width="form.labelWidth" :rules="form.rules"  style='width:500px;margin-top:30px'>
            <el-form-item :label="item.label" v-for="(item,index) in form.formItem" :key="index" :prop="item.model">
                <el-input v-model="formData[item.model]" v-if="item.type == 'input'" :autosize="item.autosize||false" :type="item.inputType"
                    :clearable="item.allowClean||false" :disabled='item.isDisable||false' :placeholder="item.placeholder||'请输入'" 
                    :rows="item.rows" :auto-complete="item.autoComplete||'off'" :suffix-icon='item.suffixIcon' :prefix-icon='item.prefixIcon' 
                    :size="item.size||'small'" :maxlength="item.maxlength">
                </el-input>
                <el-select  v-model="formData[item.model]" v-if="item.type == 'select'" :multiple="item.isMultiple||false" :size="item.size||'small'" class="full-width"
                    :clearable="item.allowClean||false" :disabled='item.isDisable||false' :placeholder="item.placeholder||'请选择'">
                    <el-option v-for="v in item.options" :key="v.value" :label="v.label" :value="v.value" :disabled='v.isDisable||false'></el-option>
                </el-select>
                <el-upload
                v-if="item.type == 'upload'"
                action="#"
                :limit="item.limit"
                list-type="picture-card"
                :on-exceed="handleExceed"
                :on-success='handleSuccess'
                :on-remove="handleRemove"
                :auto-upload="false">
                    <i slot="default" class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
                <el-date-picker
                    v-if="item.type == 'datePicker'"
                    class="full-width"
                    v-model="formData[item.model]"
                    :type="item.timeType"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
                  <el-time-picker
                    v-if="item.type == 'timePicker'"
                    :is-range="item.isRange"
                    class="full-width"
                    v-model="formData[item.model]"
                    size="item.size||'small'"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    placeholder="选择时间范围">
                </el-time-picker>                  
                <el-switch
                    v-if="item.type == 'switch'"
                    v-model="formData[item.model]"
                    :active-color="item.activeColor"
                    :inactive-color="item.inactiveColor">
                </el-switch>
                <el-checkbox-group v-model="formData.checkList" v-if="item.type == 'checkbox'">
                    <el-checkbox v-for="i in item.options" :key="i.value" :label="i.label" :disabled='i.isDisable||false'>{{i.label}}</el-checkbox>
                </el-checkbox-group>
                <el-radio-group v-model="formData[item.model]" v-if="item.type == 'radio'">
                    <el-radio v-for="i in item.options" :key="i.value" :label="i.label" :disabled='i.isDisable||false'></el-radio>
                </el-radio-group>
                <ZDAreaSelect 
                v-if="item.type == 'areaSelect'"
                :selProvince='formData.province'
                :selCity='formData.city'
                :selArea='formData.area'
                :showLevel='3'
                >
                </ZDAreaSelect>
            </el-form-item>
            <el-form-item class="flex-r-end">
                <el-button type="primary" @click="onSubmit">立即创建</el-button>
                <el-button>取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import ZDAreaSelect from '../area-select/index.vue'
export default{
    name:'formMould',
    components:{
        ZDAreaSelect
    },
    props:{
        form:{
            type:Object,
            default:{}
        }
    },
    data(){
        return{
            formData:{
                checkList: [],
            },
            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,
            // form:{
            //     ref:'infoForm',
            //     formModel:{},
            //     labelWidth:'80px'||'120px',
            //     rules:{
            //         name: [
            //             { required: true, message: '请输入姓名', trigger: 'blur' },
            //             { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
            //         ],
            //         phone: [
            //             { required: true, message: '请输入手机号', trigger: 'blur' },
            //             {
            //                 pattern: /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/,
            //                 message: '手机号填写错误',
            //                 trigger: 'blur'
            //             },
            //         ],
            //         sex: [
            //             { required: true, message: '请选择性别', trigger: 'change' },
            //         ],
            //     },
            //     formItem:[
            //         {
            //             label:'姓名',type:'input',inputType:'text',model:'name',
            //             allowClean:true,isDisable:false,placeholder:'请输入姓名',
            //             suffixIcon:"el-icon-date",//尾部显示图标
            //             prefixIcon:"el-icon-search",//首部显示图标
            //             autosize:false,
            //             maxlength:'25',
            //             size:'small',
            //             appendSolt:null
            //         },
            //         {
            //             label:'密码',type:'input',inputType:'password',model:'password',
            //             allowClean:true,isDisable:false,
            //             maxlength:'25',
            //         },
            //         {
            //             label:'描述',type:'input',inputType:'textarea',model:'name',
            //             allowClean:true,isDisable:false,rows:'3',autoComplete:'off',
            //             maxlength:'25',
            //         },
            //         {
            //             label:'手机号',type:'input',model:'phone',allowClean:true,isDisable:false,placeholder:'请输入手机号',
            //             autosize:false,
            //             maxlength:'11',
            //             size:'small',
            //         },
            //         {
            //             label:'上传',type:'upload',model:'pic',
            //         },
            //         {
            //             label:'性别',type:'select',model:'sex',allowClean:true,isDisable:false,placeholder:'请选择性别',
            //             size:'small',
            //             options:[
            //                 {
            //                     label:'男',
            //                     value:1,
            //                     isDisable:true
            //                 },
            //                 {
            //                     label:'女',
            //                     value:0
            //                 },
            //             ]
            //         },
            //         {
            //             label:'状态',type:'switch',model:'status',isDisable:false,size:'small',activeColor:'#3291f8',inactiveColor:'#ccc',
            //         },
            //         {
            //             label:'爱好',type:'checkbox',model:'hobby',isDisable:false,
            //             size:'small',
            //             options:[
            //                 {
            //                     label:'游泳',
            //                     value:0
            //                 },
            //                 {
            //                     label:'足球',
            //                     value:1,
            //                     isDisable:false
            //                 },
            //                 {
            //                     label:'羽毛球',
            //                     value:2,
            //                     isDisable:true
            //                 },
            //                 {
            //                     label:'拳击',
            //                     value:3
            //                 },
            //             ]
            //         },
            //         {
            //             label:'单选框',type:'radio',model:'radio',isDisable:false,
            //             size:'small',
            //             options:[
            //                 {
            //                     label:'游泳',
            //                     value:0
            //                 },
            //                 {
            //                     label:'足球',
            //                     value:1,
            //                     isDisable:false
            //                 },
            //                 {
            //                     label:'羽毛球',
            //                     value:2,
            //                     isDisable:true
            //                 },
            //                 {
            //                     label:'拳击',
            //                     value:3
            //                 },
            //             ]
            //         },
            //         {
            //             label:'时间间隔',type:'datePicker',timeType:'daterange',model:'timerange',isDisable:false,
            //             size:'small',
            //         },
            //         {
            //             label:'日期',type:'datePicker',timeType:'date',model:'date',isDisable:false,
            //             size:'small',
            //         },
            //         {
            //             label:'时间',type:'timePicker',timeType:'time',model:'time',isDisable:false,size:'small',isRange:false//是否是时间间隔
            //         },
            //         {
            //             label:'时间',type:'timePicker',timeType:'time',model:'timerange',isDisable:false,size:'small',isRange:true//是否是时间间隔
            //         },
            //     ]
            // }
        }
    },
    methods:{
        handleExceed(files, fileList){
            this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            // console.log(fileList);
        },
        handleRemove(files,fileList) {
            // console.log(files,fileList);
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handleSuccess(file){
            console.log('handleSuccess',file);
        },
        onSubmit(){
            this.$emit('formInfo',this.formData)
            // console.log(this.formData);
        }
    }
}

</script>

<style scoped>

</style>